<template>
  <!-- 首页-我的收藏，常用功能,C表示通用 -->
  <div class="common-collection">
    <div class="title">
      <div class="left">常用功能</div>
      <div class="right" @click="toSetting">
        <yq-icon name="24gf-gear"/>
        设置
      </div>
    </div>
    <div class="command-list">
      <div class="item" v-for="(item, i) in commandList" :key="item.moduleName" @click="moduleClick(item)">
        <div class="icon" :style="{'background': colorList[i%colorList.length]}">
          <yq-icon :name="item.moduleIcon"/>
        </div>
        <div class="name">{{item.moduleName}}</div>
      </div>
    </div>
    <el-dialog v-model="showSetting" title="常用功能" dialog-width="2">
      <dialog-table>
        <separator-page>
          <template #category>
            <el-tree ref="tree" :data="menuList" :props="{children: 'children', label: 'moduleName'}" @node-click="clickMenu" empty-text="数据为空" node-key="id" default-expand-all :expand-on-click-node="false">
              <template #default="{data}">
                <yq-icon :name="data.moduleIcon"/>
                <div>{{data.moduleName}}</div>
                <yq-icon name="element-ui_check" v-if="data.checked" style="color: #1BAB3D"/>
              </template>
            </el-tree>
          </template>
          <draggable style="height: 100%;overflow: auto;" :list="employeeCollection" :force-fallback="true" chosen-class="chosen" animation="300" @end="dragEnd" item-key="id">
            <template #item="{ element, index }">
              <div class="menu-collection-item">
                <span class="index">{{index}}</span>
                <yq-icon class="yq-icon" :name="element.moduleIcon"/>
                <div class="name">{{element.moduleName}}</div>
              </div>
            </template>
          </draggable>
        </separator-page>
      </dialog-table>
      <template #footer>
        <page-button el-type="primary" @click="showSetting = false">确定</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import commonApi from "@/api/commonApi";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import Draggable from "vuedraggable";
import xujianUtil from "@/util/XujianUtil";

export default {
  props: {
    defaultList: {default: []}, // 默认显示的列表，如果用户没有设置，就显示这个列表
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EmployeeCollection",
  components: {
    Draggable,
    YqIcon, SeparatorPage, DialogTable
  },
  data() {
    return {
      allMenuList: [], // 菜单列表，原始数据
      menuList: [], // 菜单列表
      employeeCollection: [], // 收藏夹
      commandList: [],
      colorList : ["#38d7ff","#ff7621","#ffc421","#fdea43","#9eff17","#38ff6d","#4599ff","#9e66ff","#f94aff"],
      showSetting: false,
    };
  },
  created() {
    // 从缓存中获取菜单
    this.init();
  },
  methods: {
    // 拖动排序
    dragEnd() {
      // 获取排序，排序变化的数据进行保存
      let arr = [];
      for (let i = 0; i < this.employeeCollection.length; i++) {
        if (this.employeeCollection[i].index !== i + 1) {
          arr.push({id: this.employeeCollection[i].id, index: i + 1})
        }
      }
      console.log(arr);
      if (arr.length > 0) {
        // 重新排序
        commonApi.indexEmployeeCollection(arr).then(() => {
          this.init(this.showSettingData);
        })
      }
    },
    clickMenu(data) {
      // 如果有收藏就删除，没有就保存
      if (data.checked) {
        commonApi.deleteEmployeeCollection(data.collectionId).then(() => {
          this.init(this.showSettingData);
          data.checked = false;
        })
      } else {
        let d = {moduleId: data.id, index: this.employeeCollection.length + 1}
        commonApi.saveEmployeeCollection(d).then(() => {
          this.init(this.showSettingData);
          data.checked = true;
        })
      }
    },
    // 显示常用功能设置页面
    toSetting() {
      this.showSettingData();
      this.showSetting = true;
    },
    showSettingData() {
      let menu = this.$deepClone(this.allMenuList);
      this.getMenuFromList(this.employeeCollection, menu);
      this.menuList = menu;
    },
    init(callBack) {
      let menuList = util.getSession("menuList");
      if (!menuList) {
        // 没有菜单，等一会
        setTimeout(() => {
          this.init();
        }, 300);
        return;
      }
      this.allMenuList = JSON.parse(menuList);
      // 读取收藏的常用功能
      commonApi.queryEmployeeCollection().then(list => {
        this.employeeCollection = list;
        // 没有数据的时候,显示默认,默认显示劳务人员和融合通讯平台
        if (!list || list.length === 0) {
          // 默认数据
          let arr = [];
          for (let i = 0; i < this.defaultList.length; i++) {
            arr.push({moduleId: this.defaultList[i]})
          }
          let menu = this.$deepClone(this.allMenuList);
          this.getMenuFromList(arr, menu);
          this.commandList = arr;
          this.menuList = menu;
        } else {
          let menu = this.$deepClone(this.allMenuList);
          this.getMenuFromList(list, menu);
          this.commandList = list;
          this.menuList = menu;
        }
        if (callBack) {
          callBack();
        }
      });
    },
    // 点击事件
    moduleClick(data) {
      if (data.moduleWeb === 0) {
        // 跳转到叙简平台
        xujianUtil.toXuJian();
        return;
      }
      // 跳转页面
      // 由于不是router页面，无法触发beforeRouteLeave，手动调用
      let to = { path: data.moduleComponentUri, fullPath: data.moduleComponentUri };
      util.cachePageData(null, to, {path: "/welcome", fullPath: "/welcome"});
      this.router.push({ path: data.moduleComponentUri })
    },
    getMenuFromList(list, menu) {
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < menu.length; j++) {
          if (menu[j].checked === undefined) {
            menu[j].checked = false;
          }
          if (list[i].moduleId === menu[j].id) {
            // 添加名称和图标
            list[i] = {
              ...list[i],
              moduleIcon: menu[j].moduleIcon,
              moduleComponentUri: menu[j].moduleComponentUri,
              moduleName: menu[j].moduleName,
              moduleWeb: menu[j].moduleWeb,
            };
            menu[j].checked = true;
            menu[j].collectionId = list[i].id;
            break;
          }
          if (menu[j].children &&  menu[j].children.length > 0) {
            this.getMenuFromList(list, menu[j].children);
          }
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "common";
.common-collection{
  height: 150px;
}
.command-list{
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding: 10px 0;

  /* 美化滚动条 */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }

  .item{
    display: flex;
    align-items: center;
    flex-direction: column;
    min-width: 70px;
    cursor: pointer;
    transition: var(--transition);

    &:hover{
      transform: translateY(-4px);

      .icon{
        box-shadow: 0 6px 16px rgba(0,0,0,0.15);
      }
    }

    .icon{
      border-radius: 16px;
      width: 52px;
      height: 52px;
      line-height: 52px;
      color: #FFF;
      text-align: center;
      font-size: 24px;
      margin-bottom: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      transition: var(--transition);
    }

    .name{
      font-size: 13px;
      color: #606266;
      text-align: center;
      white-space: nowrap;
    }
  }
}
// 拖动排序
.menu-collection-item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid var(--yq-border-color);
  user-select: none;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  &:hover{
    font-size: 16px;
    background: var(--yq-background-color);
    color: var(--el-color-primary);
    .index{
      background: var(--el-color-primary);
    }
  }
  .index{
    color: #FFF;
    background: var(--yq-font-color-desc);
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    text-align: center;
  }
  .name{

  }
  .yq-icon{
    padding: 0 5px;
  }
}
</style>